<template>
	<div class="card-footer">
		<slot />
	</div>
</template>

<script>
export default {
	name: 'CardFooter',
};
</script>

<style lang="scss" scoped>
.card-footer {
	border-top: solid 1px #e9e9e9;
	margin-left: -20px;
	margin-right: -20px;
	margin-top: -20px;
}
</style>



// WEBPACK FOOTER //
// src/modules/shared/components/ui/Card/CardFooter.vue